
import { ref, computed, defineComponent, onBeforeMount } from 'vue'
import { MqResponsive } from 'vue3-mq'

import AsMenu from '@web/components/AsMenu.vue'
import AsRow from '@web/components/AsRow.vue'
import AsHeaderMain from '@web/components/headers/AsHeaderMain.vue'
import AsFooter from '@web/components/AsFooter.vue'
import AsSpacer from '@web/components/AsSpacer.vue'
import AsBreadcrumb, { crumb } from '@web/components/AsBreadcrumb.vue'
import AsPreloader from '@web/components/AsPreloader.vue'
import AsBanner from '@web/components/AsBanner.vue'
import AsTechQuestion from '@web/components/AsTechQuestion.vue'
import AsModal from '@web/components/AsModal.vue'
import IconRightArrow from '@web/components/icons/IconRightArrow.vue'
import AsEmpty from '@web/components/AsEmpty.vue'
import AsBannersCatalog from '@web/components/AsBannersCatalog.vue'
import AsBannersTop from '@web/components/AsBannersTop.vue'
import AsHeaderMobile from '@web/components/headers/AsHeaderMobile.vue'

import useFAQ from '@web/composition/useFAQ'
import { useRouter } from 'vue-router'
import { useMeta } from '@web/common/vueMeta'
import i18n from '@web/plugins/i18n'

export default defineComponent({
  components: {
    MqResponsive,
    AsHeaderMobile,
    AsMenu,
    AsRow,
    AsHeaderMain,
    AsSpacer,
    AsFooter,
    AsBreadcrumb,
    AsPreloader,
    AsBanner,
    AsTechQuestion,
    AsModal,
    IconRightArrow,
    AsEmpty,
    AsBannersCatalog,
    AsBannersTop
  },
  setup () {
    const router = useRouter()
    const isOpenMenu = ref(false)
    const faq = useFAQ({ router })

    const breadcrumbs = computed<crumb[]>(() => {
      const crumbs: crumb[] = [{
        title: i18n.global.t('supportCenter'),
        name: 'support'
      }]

      if (faq.selectedCategory.value) {
        crumbs.push({
          title: faq.selectedCategory.value.title,
          name: 'support-category',
          params: {
            categoryId: String(faq.selectedCategory.value.id)
          }
        })
      }

      if (faq.selectedStream.value && faq.selectedCategory.value) {
        crumbs.push({
          title: faq.selectedStream.value.course.title,
          name: 'support-category-stream',
          params: {
            categoryId: String(faq.selectedCategory.value.id),
            streamId: String(faq.selectedStream.value.stream.id)
          }
        })
      }

      return crumbs
    })

    useMeta({
      title: faq.title
    })

    onBeforeMount(() => {
      faq.init()

      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)

      window.addEventListener('resize', () => {
        const vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      })
    })

    return {
      ...faq,
      isOpenMenu,
      breadcrumbs
    }
  }
})
